import React from "react";

import { TextField, StandardTextFieldProps, makeStyles } from '@material-ui/core'
// @material-ui/icons
// core components

import Label from "../Label/Label";

type CustomInputChangeEvent =
  | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  | { target: { id?: string; name?: string; value: unknown } };

type CustomInputElementProps = Omit<NonNullable<StandardTextFieldProps['inputProps']>, 'onChange' | 'value'> & {
  onChange?: (event: CustomInputChangeEvent) => void;
  value?: unknown;
};

// const useStyles = makeStyles((theme) => ({
//   root: {
//     background: 'transparent'
//   }
// }));
export interface CustomInputProps extends Omit<StandardTextFieldProps, 'inputProps'> {
  labelText?: string,
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>,
  id?: string,
  IsRequired?: boolean,
  inputProps?: CustomInputElementProps,
}

const useStyles = makeStyles((theme) => ({
  root: {
    // // (Note: space or no space after & matters. See SASS "parent selector".)
    // '& .MuiOutlinedInput-input': {
    //   background: (props: CustomInputProps) => props.disabled ? theme.overrides?.MuiOutlinedInput?.disabled : 'transparent',
    // },
    // '& .MuiOutlinedInput-root': {  // - The Input-root, inside the TextField-root
    //   background: 'transparent',
    //   '& input': {            // - The <fieldset> inside the Input-root
    //     background: (props: CustomInputProps) => props.disabled ? theme.overrides?.MuiOutlinedInput?.disabled : 'transparent',   // - Set the Input border
    //   },
    //   '& fieldset': {            // - The <fieldset> inside the Input-root
    //     background: (props: CustomInputProps) => props.disabled ? theme.overrides?.MuiOutlinedInput?.disabled : 'transparent',   // - Set the Input border
    //   },
    // },

  },
}))


export default function CustomInput(props: CustomInputProps) {
  const classes = useStyles(props);
  var {
    labelText,
    id,
    IsRequired,
    labelProps,
    disabled,
    inputProps,
    ...rest
  } = props;



  return (
    <>
      <Label labelText={labelText || id || ''} IsRequired={IsRequired} />

      <TextField
        id={id}
        placeholder={disabled ? "" : "Input here..."}
        fullWidth
        variant="outlined"
        size="small"
        disabled={disabled}
        classes={classes}
        inputProps={inputProps as StandardTextFieldProps['inputProps']}
        {...rest}
      />

    </>
  )
}
